module.exports = "<rm-strategy-readonly strategy=rowDetailsStrategy show-drag-bar=false collapsed=false></rm-strategy-readonly>";